import AccountMenu from './AccountMenu';

export default AccountMenu;
